import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// System share sheet for a link (sindi-ios ShareComponent.swift). Loads only
// when the shell advertises the "share" bridge component; the element's
// invite-share values supply the title, text and URL.
export default class extends BridgeComponent {
  static component = "share"

  open(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const data = this.element.dataset
    const rect = this.element.getBoundingClientRect()
    this.send("share", {
      title: data.inviteShareTitleValue || "",
      text: data.inviteShareTextValue || "",
      url: data.inviteShareUrlValue,
      anchor: { x: rect.left, y: rect.top, width: rect.width, height: rect.height }
    })
  }
}
